import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import axios from 'axios';
import './TopAlgorithmsChart.css';

const TopAlgorithmsChart = () => {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fixedColors = [
    'rgba(255,99,132,1)',
    'rgba(54,162,235,1)',
    'rgba(255,206,86,1)',
    'rgba(75,192,192,1)',
    'rgba(153,102,255,1)',
  ];

  useEffect(() => {
    const fetchChartData = async () => {
      try {
        const { data } = await axios.get('/api/top-algorithms');
        if (data.success) {
          const { labels, datasets } = processChartData(data.data);
          setChartData({ labels, datasets });
        } else {
          setError('Failed to fetch chart data.');
        }
      } catch (err) {
        console.error('Error fetching chart data:', err);
        setError('Server connection error.');
      } finally {
        setLoading(false);
      }
    };

    fetchChartData();
  }, []);

  const processChartData = (data) => {
    const labels = [...new Set(data.map((item) => item.time_interval))];
    const algorithms = [...new Set(data.map((item) => item.algo))];

    const datasets = algorithms.map((algo, index) => {
      const algoData = data.filter((item) => item.algo === algo);
      return {
        label: algo,
        data: labels.map((label) => {
          const match = algoData.find((item) => item.time_interval === label);
          return match ? match.avg_miners : 0;
        }),
        borderColor: fixedColors[index] || getRandomColor(),
        backgroundColor: 'rgba(0,0,0,0)',
        tension: 0.4,
        borderWidth: 2,
        pointRadius: 0,
        hoverRadius: 0,
      };
    });

    return { labels, datasets };
  };

  const getRandomColor = () => {
    const r = Math.floor(Math.random() * 255);
    const g = Math.floor(Math.random() * 255);
    const b = Math.floor(Math.random() * 255);
    return `rgba(${r}, ${g}, ${b}, 1)`;
  };

  if (loading) {
    return <p className="chart-loading">Loading chart data...</p>;
  }

  if (error) {
    return <p className="chart-error">{error}</p>;
  }

  return (
    <div className="chart-container">
      <h4 className="chart-title">Algorithm Miner Trends (Last 30 Days)</h4>
      {chartData ? (
        <Line
          data={chartData}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
              legend: {
                position: 'top',
                labels: {
                  font: {
                    size: 14,
                  },
                },
              },
              title: {
                display: false,
              },
            },
            scales: {
              x: {
                title: {
                  display: true,
                  text: 'Time Interval',
                  font: {
                    size: 14,
                    weight: 'bold',
                  },
                  color: '#333',
                },
                ticks: {
                  display: false,
                },
                grid: {
                  drawTicks: false,
                },
              },
              y: {
                title: {
                  display: true,
                  text: 'Average Miners',
                  font: {
                    size: 14,
                    weight: 'bold',
                  },
                  color: '#333',
                },
                ticks: {
                  stepSize: 1000,
                  color: '#666',
                  font: {
                    size: 12,
                  },
                },
                grid: {
                  color: 'rgba(0, 0, 0, 0.1)',
                  lineWidth: 1,
                },
              },
            },
          }}
        />
      ) : (
        <p className="chart-no-data">No data available for the chart.</p>
      )}
    </div>
  );
};

export default TopAlgorithmsChart;
